"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SUPPORTED_LOCALE_CODES", {
  enumerable: true,
  get: function () {
    return _supportedLocales.default;
  }
});
Object.defineProperty(exports, "cs", {
  enumerable: true,
  get: function () {
    return _cs.default;
  }
});
Object.defineProperty(exports, "da", {
  enumerable: true,
  get: function () {
    return _da.default;
  }
});
Object.defineProperty(exports, "de", {
  enumerable: true,
  get: function () {
    return _de.default;
  }
});
Object.defineProperty(exports, "en", {
  enumerable: true,
  get: function () {
    return _en.default;
  }
});
Object.defineProperty(exports, "en_GB", {
  enumerable: true,
  get: function () {
    return _enGB.default;
  }
});
Object.defineProperty(exports, "es", {
  enumerable: true,
  get: function () {
    return _es.default;
  }
});
Object.defineProperty(exports, "fr", {
  enumerable: true,
  get: function () {
    return _fr.default;
  }
});
Object.defineProperty(exports, "fr_CA", {
  enumerable: true,
  get: function () {
    return _frCA.default;
  }
});
Object.defineProperty(exports, "it", {
  enumerable: true,
  get: function () {
    return _it.default;
  }
});
Object.defineProperty(exports, "ja", {
  enumerable: true,
  get: function () {
    return _ja.default;
  }
});
Object.defineProperty(exports, "ko", {
  enumerable: true,
  get: function () {
    return _ko.default;
  }
});
Object.defineProperty(exports, "nl", {
  enumerable: true,
  get: function () {
    return _nl.default;
  }
});
Object.defineProperty(exports, "no", {
  enumerable: true,
  get: function () {
    return _no.default;
  }
});
Object.defineProperty(exports, "pl", {
  enumerable: true,
  get: function () {
    return _pl.default;
  }
});
Object.defineProperty(exports, "pt_BR", {
  enumerable: true,
  get: function () {
    return _ptBR.default;
  }
});
Object.defineProperty(exports, "sv", {
  enumerable: true,
  get: function () {
    return _sv.default;
  }
});
Object.defineProperty(exports, "zh", {
  enumerable: true,
  get: function () {
    return _zh.default;
  }
});
Object.defineProperty(exports, "zh_Hant", {
  enumerable: true,
  get: function () {
    return _zhHant.default;
  }
});
var _cs = _interopRequireDefault(require("./cs.json"));
var _da = _interopRequireDefault(require("./da.json"));
var _de = _interopRequireDefault(require("./de.json"));
var _enGB = _interopRequireDefault(require("./en-GB.json"));
var _en = _interopRequireDefault(require("./en.json"));
var _es = _interopRequireDefault(require("./es.json"));
var _frCA = _interopRequireDefault(require("./fr-CA.json"));
var _fr = _interopRequireDefault(require("./fr.json"));
var _it = _interopRequireDefault(require("./it.json"));
var _ja = _interopRequireDefault(require("./ja.json"));
var _ko = _interopRequireDefault(require("./ko.json"));
var _nl = _interopRequireDefault(require("./nl.json"));
var _no = _interopRequireDefault(require("./no.json"));
var _pl = _interopRequireDefault(require("./pl.json"));
var _ptBR = _interopRequireDefault(require("./pt-BR.json"));
var _sv = _interopRequireDefault(require("./sv.json"));
var _zh = _interopRequireDefault(require("./zh.json"));
var _zhHant = _interopRequireDefault(require("./zh-Hant.json"));
var _supportedLocales = _interopRequireDefault(require("./supportedLocales"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }